import { Injectable, RendererFactory2, ViewEncapsulation, inject, DOCUMENT } from '@angular/core';
import { envs } from '@environments';

@Injectable({
  providedIn: 'root',
})
export class SchemaService {
  private readonly document = inject(DOCUMENT);
  private readonly renderer = inject(RendererFactory2);

  setJsonLd(data: any): void {
    try {
      const renderer = this.renderer.createRenderer(this.document, {
        id: '-1',
        encapsulation: ViewEncapsulation.None,
        styles: [],
        data: {},
      });
      const script = renderer.createElement('script');
      script.type = 'application/ld+json';
      script.text = `${JSON.stringify(data, null, 2)}`;
      renderer.appendChild(this.document.body, script);
    } catch (e) {
      console.error('Error within SchemaService : ', e);
    }
  }

  setWebsiteObjectJsonLd() {
    this.setJsonLd({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      id: `${envs.siteUrl}/#webSite`,
      url: envs.siteUrl,
      name: 'شیدا',
      creator: {
        '@type': 'organization',
        id: `${envs.siteUrl}/#organization`,
        name: 'شیدا',
      },
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${envs.siteUrl}/search/{search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    });
  }

  handleDuration(duration: number): string {
    const durationHour = Math.floor(+duration / 3600) > 0 ? `${Math.floor(duration / 3600)}H` : '';
    const durationMinute =
      Math.floor((duration % 3600) / 60) > 0 ? `${Math.floor((duration % 3600) / 60)}M` : '';
    const durationSecond =
      duration - Math.floor(duration / 3600) * 3600 - Math.floor((duration % 3600) / 60) * 60 + 'S';
    return 'PT' + durationHour + durationMinute + durationSecond;
  }

  removeJsonLdScripts() {
    this.document.querySelectorAll("script[type='application/ld+json']").forEach((script) => {
      script.remove();
    });
  }
}
